import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {addEditPolicyExchange, delPolicyExchange, getPolicyExchanges} from '../../services';
import {IPolicyExchange, IPolicyExchangeFilter, IPolicyExchangeRes, IPolicyExchangeState} from "../types/IPolicyExchange";
import historyHelper from "../../helpers/history";
import {AppState} from "./rootReducer";

const initialState: IPolicyExchangeState = {
    status: "idle"
}

export const mostrarPolicyExchanges = createAsyncThunk(
    'mostrarPolicyExchanges', async (params:IPolicyExchangeFilter|undefined, thunkAPI ) => {
        const {policyExchanges} = thunkAPI.getState() as AppState;
        let paramsFilter = params || policyExchanges.filtered;

        const response = await getPolicyExchanges(paramsFilter)
        return {data: response.data as IPolicyExchangeRes, params: response.config.params}
    }
)

export const mostrarPolicyExchangeById = createAsyncThunk(
    'mostrarPolicyExchangeById', async (id:number ) => {

        const response = await getPolicyExchanges(id)
        return response.data as IPolicyExchange
    }
)



export const agregarEditarPolicyExchange = createAsyncThunk(
    'PolicyExchanges/agregarEditar', async (policyExchange: IPolicyExchange) => {
        const response = await addEditPolicyExchange(policyExchange);
        if (response.status === 200 || response.status === 204) historyHelper.back();
        return {data: response.data, edit:!!policyExchange.id};
    }
);

export const eliminarPolicyExchange = createAsyncThunk(
    'policyExchange/eliminar', async (id: number) => {
        const response = await delPolicyExchange(id);
        if (response.status === 200 || response.status === 204) historyHelper.replace("policyExchanges");
        return id;
    }
);


const slice = createSlice({
    name: 'mostrarPolicyExchanges',
    initialState,
    reducers: {
    },
    extraReducers: builder => {
        //--mostrarPolicyExchanges
        builder.addCase(mostrarPolicyExchanges.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarPolicyExchanges.fulfilled, (state,action ) => {
            state.status = "idle";
            state.filtered = action.payload.params;
            state.list = action.payload.data;
        })
        builder.addCase(mostrarPolicyExchanges.rejected, (state ) => {
            state.status = "idle";
        })
        //---mostrarPolicyExchangeById
        builder.addCase(mostrarPolicyExchangeById.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarPolicyExchangeById.fulfilled, (state,action ) => {
            state.status = "idle";
            state.byId = action.payload;
        })
        builder.addCase(mostrarPolicyExchangeById.rejected, (state ) => {
            state.status = "idle";
        })
        //--agregarEditarPolicyExchange
        builder.addCase(agregarEditarPolicyExchange.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(agregarEditarPolicyExchange.fulfilled, (state,action ) => {
            state.status = "idle";
            if(state.list){
                state.list.items = state.list?.items.filter(e => e.id !== action.payload.data.id);
                state.list.items.unshift(action.payload.data);
                if(!action.payload.edit){
                    ++state.list.pageSize
                    ++state.list.totalCount
                }

            }
        })
        builder.addCase(agregarEditarPolicyExchange.rejected, (state ) => {
            state.status = "idle";
        })
        //--eliminarPolicyExchange
        builder.addCase(eliminarPolicyExchange.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(eliminarPolicyExchange.fulfilled, (state,action ) => {
            state.status = "idle";
            const id = action.payload;
            if(state.list?.items){
                state.list.items = state.list?.items.filter(e => e.id !== id)
            }
        })
        builder.addCase(eliminarPolicyExchange.rejected, (state ) => {
            state.status = "idle";
        })
    }
});

export default slice.reducer;
